import React, { useContext } from 'react'
import { observer } from 'mobx-react'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'
import AddPublishersTable from '@Scenes/WorkScenes/Steps/PublishersSteps/PublishersStep/AddPublishersArea/AddPublishersTable'

const AddPublishersArea = () => {
    const { workStore } = useContext<RootStore>(StoresContext)

    const workDraftFromLocal = workStore.workDraftLocal
    if (!workDraftFromLocal) {
        return <></>
    }

    return (
        <div className="publishers-add-area">
            <AddPublishersTable />
        </div>
    )
}

export default observer(AddPublishersArea)
